import React, { useEffect, useRef } from "react";

const PaymentRedirect = ({ formData }) => {
  const ref = useRef(null);
  useEffect(() => {
    const form = ref.current?.querySelector("form");
    if (form && !form.dataset.submitted) {
      form.dataset.submitted = "true";
      form.submit();
    }
  }, []);

  return (
      <div
        ref={ref}
        dangerouslySetInnerHTML={{ __html: formData }}
      />
  );
};

export default PaymentRedirect;
